import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative min-h-[500px] xs:min-h-[600px] h-screen">
      <div className="absolute inset-0">
        <img
          src="/images/hero-background.jpg"
          alt="Hero background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
      </div>
      
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <h1 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-white font-playfair leading-tight mb-3 xs:mb-4 sm:mb-6">
            Timeless Craftsmanship, Tailored for You
          </h1>
          <p className="text-sm xs:text-base sm:text-lg md:text-xl text-white/90 font-lora mb-4 xs:mb-6 sm:mb-8 max-w-2xl leading-relaxed">
            Based in Bagru, ANG creates handcrafted furniture, serveware, and home décor using solid wood, metal, and marble — for architects, interior designers, and retail buyers who value quality and soul in every piece.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 max-w-md sm:max-w-none mx-auto sm:mx-0">
            <Link
              to="/products"
              className="w-full sm:w-auto min-w-[160px] text-center inline-block bg-[#B38053] text-white px-5 xs:px-6 sm:px-8 py-2.5 xs:py-3 rounded-md font-lora hover:bg-[#96663D] transition-all duration-300 text-sm xs:text-base"
            >
              Explore Collection
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto min-w-[160px] text-center inline-block border-2 border-white text-white px-5 xs:px-6 sm:px-8 py-2.5 xs:py-3 rounded-md font-lora hover:bg-white hover:text-[#B38053] transition-all duration-300 text-sm xs:text-base"
            >
              Our Story
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
 